export enum State {
  FORM = 'form',
  SEND_FORM = 'send-form',

  REFUSED = 'refused',

  DONE = 'done',
  ABORT = 'abort',
}
